import React from "react";

export type SvgIconProps = React.SVGProps<SVGSVGElement>;

const SvgIcon = ({ children, ...props }: SvgIconProps) => (
  <svg
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="currentColor"
    {...props}
  >
    {children}
  </svg>
);

export default SvgIcon;
